<form *ngIf="model" (ngSubmit)="requiresCompanyDetailsConfirmation() ? confirmCompanyDetailsChangeForSubmit() : onSubmit()" [formGroup]="form" class="pos-relative form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>

  <h2>My account</h2>

  <div class="parent-account-container alert alert-primary my-20" *ngIf="parentAccountDetails">
    <div class="text-primary d-flex justify-content-start align-items-center gap-10">
      <span class="icon-info-1"></span>
      Parent account is:<strong>{{parentAccountDetails.email}}</strong>
    </div>
  </div>

  <div class="section profile-section">
    <h3 class="mb-25 fw-[400]">Profile info</h3>
    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Full name </label>
        <div>
          <input [(ngModel)]="model.fullName" formControlName="fullName" type="text" class="form-control">
          <input-errors [control]="form.controls.fullName" [service]="validationService"></input-errors>
        </div>
      </div>
      <div class="form-group w-100">
        <label class="form-label required">Username </label>
        <div>
          <input [(ngModel)]="model.username" formControlName="username" type="text" class="form-control">
          <input-errors [control]="form.controls.username" [service]="validationService"></input-errors>
        </div>
      </div>
    </div>
    <div class="form-row d-flex gap-25">
      <div class="form-group w-100">
        <label class="form-label required">Phone </label>
        <div>
          <input [(ngModel)]="model.phone" formControlName="phone" type="text" class="form-control" placeholder="+351 765 653 765">
          <input-errors [control]="form.controls.phone" [service]="validationService"></input-errors>
        </div>
      </div>
      <div class="form-group w-100">
        <div class="d-flex justify-content-start">
          <label class="form-label">Email </label><span class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
            [tooltip]="'If you need to change your email, please ask your account manager'" [tooltipPlacement]="'right'"></span>
        </div>
        <div>
          <input [(ngModel)]="model.email" [ngModelOptions]="{standalone: true}" type="text" class="form-control" disabled>
        </div>
      </div>
    </div>
    <div class="apply-button d-flex justify-content-end mt-25">
      <button type="button" (click)="applyProfileChanges()" [disabled]="!isProfileSectionValid()" class="btn btn-primary">Apply changes</button>
    </div>
  </div>

  <div class="section company-information-section">
    <h3 class="mb-15">Company Details</h3>

    <div class="alert alert-primary mb-25 d-flex justify-content-start align-items-center gap-10" *ngIf="isMain() || isDeputy()">
      <span class="icon-info-1 text-primary fs-2 ms-0_5"></span>
      <span>
        Please provide accurate and complete company details. <br>The details you enter will be included in your agreement and used to generate invoices
        in the future.
      </span>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100" *ngIf="canEditSharedAccountSettings()">
        <label class="form-label required">Company Name </label>
        <div>
          <input [(ngModel)]="model.companyName" formControlName="companyName" type="text" class="form-control">
          <input-errors [control]="form.controls.companyName" [service]="validationService"></input-errors>
        </div>
      </div>
      <div class="form-group w-100" *ngIf="canEditSharedAccountSettings()">
        <label class="form-label">Website</label>
        <div>
          <input [(ngModel)]="model.websiteUrl" formControlName="websiteUrl" type="text" class="form-control">
          <input-errors [control]="form.controls.websiteUrl" [service]="validationService"></input-errors>
        </div>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Country </label>
        <div>
          <select [(ngModel)]="model.countryCode" (ngModelChange)="onCountryChange($event)" formControlName="countryCode" class="form-control">
            <option *ngFor="let country of countries" [value]="country.code">
              {{country.name}}
            </option>
          </select>
          <input-errors [control]="form.controls.countryCode" [service]="validationService"></input-errors>
        </div>
      </div>
      <div class="form-group w-100 d-flex gap-15">
        <div class="form-group w-50">
          <label class="form-label">State</label>
          <div>
            <input [(ngModel)]="model.addressState" formControlName="addressState" type="text" class="form-control">
            <input-errors [control]="form.controls.addressState" [service]="validationService"></input-errors>
          </div>
        </div>
        <div class="form-group w-50">
          <label class="form-label required">City</label>
          <div>
            <input [(ngModel)]="model.addressCity" formControlName="addressCity" type="text" class="form-control">
            <input-errors [control]="form.controls.addressCity" [service]="validationService"></input-errors>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Street</label>
        <div>
          <input [(ngModel)]="model.addressStreet" formControlName="addressStreet" type="text" class="form-control">
          <input-errors [control]="form.controls.addressStreet" [service]="validationService"></input-errors>
        </div>
      </div>
      <div class="form-group w-100">
        <label class="form-label">Zip</label>
        <div>
          <input [(ngModel)]="model.addressZip" formControlName="addressZip" type="text" class="form-control">
          <input-errors [control]="form.controls.addressZip" [service]="validationService"></input-errors>
        </div>
      </div>
    </div>

    <div class="form-row d-flex gap-25">
      <div class="form-group w-100" *ngIf="canEditSharedAccountSettings()">
        <div class="d-flex justify-content-start">
          <label class="form-label" [ngClass]="{ required: getVatNumberRequired() }">VAT number</label>
          <span class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
            [tooltip]="'A tax applied to goods and services in the European Union. <br>If your company is registered in the EU, please enter your valid VAT number. This helps us apply the correct tax rate or exemption under EU rules.'"
            [tooltipPlacement]="'right'"></span>
        </div>
        <div>
          <input [(ngModel)]="model.vatNumber" formControlName="vatNumber" type="text" class="form-control">
          <input-errors [control]="form.controls.vatNumber" [service]="validationService"></input-errors>
        </div>
      </div>
      <div hidden class="form-group">
        <label class="form-label">VAT Percentage</label>
        <div class="d-flex justify-content-start align-items-center gap-15 mt-0_5">
          <div class="form-check mb-0_7 d-flex justify-content-start align-items-center gap-0_5">
            <input value="0" [(ngModel)]="model.vatPercentage" formControlName="vatPercentage" class="form-check-input radio" type="radio" />
            <label class="form-check-label cp"> 0 % </label>
          </div>
          <div class="form-check mb-0_7 d-flex justify-content-start align-items-center gap-0_5">
            <input value="19" [(ngModel)]="model.vatPercentage" formControlName="vatPercentage" class="form-check-input radio" type="radio" />
            <label class="form-check-label cp"> 19 % </label>
          </div>
        </div>
      </div>
      <div class="form-group w-100">
        <div class="d-flex justify-content-start">
          <label class="form-label">Business unit/department</label>
          <span class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
            [tooltip]="'Specify your department or business unit if you require separate billing and invoices under the same company details.'"
            [tooltipPlacement]="'right'"></span>
        </div>
        <div>
          <input [(ngModel)]="model.departmentName" formControlName="departmentName" type="text" class="form-control">
          <input-errors [control]="form.controls.departmentName" [service]="validationService"></input-errors>
        </div>
      </div>
    </div>

    <div class="apply-button d-flex justify-content-end mt-25">
      <button *ngIf="!isSub()" type="button" (click)="applyCompanyChanges()" [disabled]="!isCompanySectionValid()" class="btn btn-primary">Apply
        changes</button>
    </div>
  </div>

  <div class="section legal-contacts-section">
    <h3 class="mb-15">Legal &amp; Operational Contacts</h3>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label required">Data Protection Officer (DPO) Email </label>
        <div>
          <input [(ngModel)]="model.dataProtectionOfficerEmail" formControlName="dataProtectionOfficerEmail" type="email" class="form-control">
          <input-errors [control]="form.controls.dataProtectionOfficerEmail" [service]="validationService"></input-errors>
        </div>
      </div>
      <div class="form-group w-100">
        <label class="form-label">Legal Representative Email </label>
        <div>
          <input [(ngModel)]="model.legalRepresentativeEmail" formControlName="legalRepresentativeEmail" type="email" class="form-control">
          <input-errors [control]="form.controls.legalRepresentativeEmail" [service]="validationService"></input-errors>
        </div>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100">
        <label class="form-label">Procurement/Routing Email </label>
        <div>
          <input [(ngModel)]="model.procurementEmail" formControlName="procurementEmail" type="email" class="form-control">
          <input-errors [control]="form.controls.procurementEmail" [service]="validationService"></input-errors>
        </div>
      </div>
    </div>

    <div class="apply-button d-flex justify-content-end mt-25">
      <button *ngIf="!isSub()" type="button" (click)="applyLegalContactsChanges()" [disabled]="!isLegalContactsSectionValid()"
        class="btn btn-primary">Apply changes</button>
    </div>
  </div>

  <div class="section platform-settings-section" *ngIf="shouldShowPlatformSettings()">
    <h3 class="mb-25 fw-[400]">Platform Settings</h3>

    <div class="form-row d-flex gap-25 mb-25" *ngIf="canEditInvoiceRecipients()">
      <div class="form-group w-100">
        <div class="d-flex justify-content-start">
          <label class="form-label">Invoice emails</label>
          <span class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
            [tooltip]="'Comma-separated email addresses that should receive invoices. Your account email is used when this list is empty.'"
            [tooltipPlacement]="'right'"></span>
        </div>
        <input [(ngModel)]="invoiceEmails" formControlName="invoiceEmails" type="text" class="form-control"
          [readonly]="!invoiceRecipientsLoaded">
        <input-errors [control]="form.controls.invoiceEmails" [service]="validationService"></input-errors>
      </div>
      <div class="form-group w-100" *ngIf="canEditSharedAccountSettings()">
        <div class="d-flex justify-content-start">
          <label class="form-label">Default SMS TTL</label>
          <span class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
            [tooltip]="'Time-to-live value determines how long (in minutes) the system will wait for a final receipt status for test SMS before considering it as a negative. Default value applies to all related accounts but can be changed in Settings of LNT test.'"
            [tooltipPlacement]="'right'"></span>
        </div>
        <div class="input-group">
          <input [(ngModel)]="model.testTtl" formControlName="testTtl" type="text" class="form-control">
          <span class="d-flex justify-content-center align-items-center input-group-text">min</span>
        </div>
        <input-errors [control]="form.controls.testTtl" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row d-flex gap-25 mb-25" *ngIf="isAccountPrepaid()">
      <div class="form-group w-100">
        <label class="form-label">Low Balance Alert Email</label>
        <div>
          <input [(ngModel)]="model.emailForAlert" formControlName="emailForAlert" type="email" class="form-control">
          <input-errors [control]="form.controls.emailForAlert" [service]="validationService"></input-errors>
        </div>
      </div>
      <div class="form-group w-100">
        <label class="form-label">Minimal Balance Amount</label>
        <div class="input-group">
          <input [(ngModel)]="model.minBalance" formControlName="minBalance" type="text" class="form-control">
          <span class="d-flex justify-content-center align-items-center input-group-text">&euro;</span>
        </div>
        <input-errors [control]="form.controls.minBalance" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row d-flex gap-15" *ngIf="!hasParentAccount() || isDeputy()">
      <div class="form-group w-100">
        <div class="d-flex justify-content-start">
          <label class="form-label">Back-up tests </label>
          <span class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
            [tooltip]="'Enable this option to have our platform issue a back-up test any time a number becomes temporary unavailable. <br>A clone of your test will be sent to a different number of the same MCCMNC free of charge.'"
            [tooltipPlacement]="'right'" [tooltipClass]="'text-start'"></span>
        </div>
        <div class="form-check form-switch">
          <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.testRetriesEnabled" formControlName="testRetriesEnabled" />
        </div>
      </div>
    </div>

    <div class="apply-button d-flex justify-content-end mt-25">
      <button type="button" (click)="applyPlatformChanges()" [disabled]="!isPlatformSectionValid()" class="btn btn-primary">Apply changes</button>
    </div>
  </div>


  <div class="section security-section">
    <h3 class="mb-15">Security & Login</h3>

    <div class="alert alert-primary mb-25 d-flex justify-content-start align-items-center gap-10">
      <span class="icon-info-1 text-primary fs-2 ms-0_5"></span>
      <span>
        To protect your account, email OTP is required and enabled by default.
      </span>
    </div>

    <div class="form-row d-flex gap-15">
      <div class="form-group w-100 d-flex justify-content-between align-items-center">
        <div>
          <div class="d-flex justify-content-start">
            <label class="form-label">Mobile Authenticator App</label>
            <span class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
              [tooltip]="'Use an authenticator app on your phone to generate secure login codes for two-factor authentication.'"
              [tooltipPlacement]="'right'"></span>
          </div>
          <span class="text-neutral-n6">To better protect your account, we advise to enable additional authentication.</span>
        </div>
        <div class="d-flex justify-content-center align-items-center gap-25">
          <div class="d-flex align-items-center gap-0_5">
            <span [ngClass]="{'icon-positive text-success-s2 fs-3': model.mfaEnabled, 'icon-attention text-error-r3 fs-3': !model.mfaEnabled}"></span>
            <span>{{model.mfaEnabled ? 'Enabled' : 'Disabled'}}</span>
          </div>
          <div>
            <button *ngIf="!model.mfaEnabled" type="button" class="btn btn-outline-primary px-20" (click)="onClickMfaEnable()">Enable</button>
            <button *ngIf="model.mfaEnabled" type="button" class="btn btn-outline-danger px-20" (click)="onClickMfaDisable()">Disable</button>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="form-row d-flex gap-25 mb-25">
      <div class="form-group w-100" *ngIf="isDeputy() || isMain() || isAdmin()">
        <div class="d-flex justify-content-start">
          <label class="form-label">Restrict Testing with IP whitelisting</label>
          <span class="icon-help-1 text-neutral-n6 fs-4 ms-0_5"
            tooltip="Only users connecting from the specified IPs will be able to trigger tests on the platform. This restriction applies to all the subaccounts, as well as the main and deputy accounts"></span>
        </div>
        <div class="noti-email-section">
          <form [formGroup]="ipWhitelistForm" class="pos-relative form">
            <div class="pills-btn pills-btn-v2" *ngFor="let address of ipWhitelistAddressList">
              <span class="text"> {{ address }}</span>
              <span class="icon icon-close" (click)="onRemoveIpWhitelistAddress(address)"></span>
            </div>
            <div class="email-holder">
              <input formControlName="ipWhitelistAddress" type="text" class="form-control" (keyup.enter)="onSubmitIpWhitelistAddressForm()"
                (blur)="onSubmitIpWhitelistAddressForm()" placeholder="Enter network or IP address to whitelist" />
              <input-errors [control]="ipWhitelistForm.controls.ipWhitelistAddress" [service]="validationService"></input-errors>
              <div *ngIf="ipWhitelistForm.controls.ipWhitelistAddress.hasError('customError')" class="input-errors">
                <span class="text-error-r2">
                  {{ ipWhitelistForm.controls.ipWhitelistAddress.getError('customError') }}
                </span>
              </div>
            </div>
          </form>
          <div class="apply-button d-flex justify-content-end mt-25">
            <button type="button" (click)="applySecurityChanges()" [disabled]="!ipWhitelistForm.valid" class="btn btn-primary">Apply changes</button>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row d-flex gap-15 justify-content-end">
      <button (click)="passwordModalOpen()" type="button" class="btn btn-outline-dark">Change password</button>
      <button (click)="showDevicesModal()" type="button" class="btn btn-outline-dark">Connected devices</button>
      <button *ngIf="isAdmin()" (click)="changeEmailModalOpen()" type="button" class="btn btn-outline-danger">Change Email</button>
      <button (click)="logout()" type="button" class="btn btn-outline-danger">Logout</button>
    </div>
  </div>
</form>

<ng-template #disableMfaModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Disable 2FA</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body mfa-modal-body">
    <div [hidden]="!mfaLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div class="alert alert-info">
      This reduces the security level of your account and is not recommended.
    </div>
    <div class="hr-line-dashed"></div>
    <div class="mfa-form">
      <form (ngSubmit)="mfaDisableOnSubmit()" [formGroup]="mfaForm" class="form">
        <div class="form-group">
          <div class="input-group my-15 code-container">
            <input [(ngModel)]="mfaModel.mfaCode" (ngModelChange)="onMfaCodeDisableChange($event)" formControlName="mfaCode" class="form-control"
              placeholder="2FA code">
            <div class="input-group-btn action-btn">
              <button type="submit" class="btn btn-primary" [disabled]="!mfaForm.valid"><i class="fa fa-paper-plane"></i></button>
            </div>
          </div>
          <input-errors [control]="mfaForm.controls.mfaCode" [service]="validationService"></input-errors>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button [disabled]="mfaLoading" type="button" class="btn btn-outline-danger mt-15" (click)="dialogRef.close()">Cancel</button>
  </div>
</ng-template>

<ng-template #mfaSetupModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block" *ngIf="!model.mfaEnabled">Connect your app</h3>
      <h3 class="d-inline-block" *ngIf="model.mfaEnabled">Recovery codes</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body pos-relative mfa-modal-body">
    <div [hidden]="!mfaLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <ng-container *ngIf="mfaSetup && !model.mfaEnabled">
      <div class="alert alert-info">
        Using an authenticator app like Authy, 1Password, Microsoft Authenticator, or Google Authenticator, scan the QR code.
      </div>
      <div class="mfa-qr text-center">
        <img [src]="mfaSetup.qrCode" alt="2FA QR code" />
        <div class="form-group">
          <label>Or copy code for manual entry:</label>
          <div class="input-group my-15 code-container">
            <input [value]="mfaSetup.secret" class="form-control" readonly disabled>
            <div class="input-group-btn action-btn">
              <button type="button" class="btn btn-primary" (click)="copyToClipboard(mfaSetup.secret)"><i class="fa fa-copy"></i></button>
            </div>
          </div>
        </div>
      </div>
      <div class="hr-line-dashed"></div>
      <div class="mfa-form">
        <form (ngSubmit)="mfaSetupOnSubmit()" [formGroup]="mfaForm" class="form">
          <div class="form-group">
            <label>Once you have connected your app, enter your most recent 6 digit verification code:</label>
            <div class="input-group my-15 code-container">
              <input [(ngModel)]="mfaModel.mfaCode" (ngModelChange)="onMfaCodeChange($event)" formControlName="mfaCode" class="form-control">
              <div class="input-group-btn action-btn">
                <button type="submit" class="btn btn-primary" [disabled]="!mfaForm.valid"><i class="fa fa-paper-plane"></i></button>
              </div>
            </div>
            <input-errors [control]="mfaForm.controls.mfaCode" [service]="validationService"></input-errors>
          </div>
        </form>
      </div>
    </ng-container>
    <ng-container *ngIf="mfaSetup && model.mfaEnabled">
      <div class="alert alert-info">
        If you lose access to your authenticator app, you can use these backup codes to gain access to your account.
        <br>
        Make a copy of your codes. Store them using a password manager like LastPass or 1Password , or in an encrypted file.
      </div>
      <app-mfa-recovery-codes [codes]="mfaSetup.recoveryCodes"></app-mfa-recovery-codes>
    </ng-container>
  </div>
  <div *ngIf="mfaSetup" class="modal-footer">
    <button *ngIf="model.mfaEnabled" type="button" class="btn btn-outline-primary mt-15" (click)="mfaModal.close(true)">Done</button>
    <button *ngIf="!model.mfaEnabled" type="button" class="btn btn-outline-danger mt-15" (click)="mfaModal.close(false)">Cancel</button>
  </div>
</ng-template>

<ng-template #passwordModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Change Password</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form (ngSubmit)="onPasswordSubmit()" [formGroup]="passwordForm" class="password-form">
      <div [hidden]="!loading" class="spinner">
        <div class="sk-spinner sk-spinner-pulse"></div>
      </div>

      <div class="form-group position-relative">
        <label for="Create Password" class="form-label required">Current Password </label>
        <input [(ngModel)]="passwordModel.currentPassword" formControlName="currentPassword" [attr.type]="currentPasswordType" placeholder="Current Password"
          class="form-control" autocomplete="new-password" />
        <span class="icon position-absolute" (click)="togglePasswordType('currentPassword')"
          [ngClass]="{ 'icon-show': !isPasswordType('currentPassword'), 'icon-hide': isPasswordType('currentPassword') }"></span>
        <input-errors [control]="passwordForm.controls.currentPassword" [service]="validationService"></input-errors>
      </div>
      <div class="hr-line-dashed"></div>

      <div class="form-group position-relative">
        <label class="form-label required">New Password </label>
        <input [(ngModel)]="passwordModel.newPassword" formControlName="newPassword" [attr.type]="newPasswordType" placeholder="New Password"
          class="form-control" autocomplete="new-password" />
        <span class="icon position-absolute" (click)="togglePasswordType('newPassword')"
          [ngClass]="passwordForm.controls.newPassword.pending ? 'icon-wait spin' : { 'icon-show': !isPasswordType('newPassword'), 'icon-hide': isPasswordType('newPassword') }"></span>
        <input-errors [control]="passwordForm.controls.newPassword" [service]="validationService"></input-errors>
      </div>

      <div class="form-group position-relative">
        <label class="form-label required">Repeat new password </label>
        <input [(ngModel)]="passwordModel.repeatNewPassword" formControlName="repeatNewPassword" [attr.type]="newPasswordType" placeholder="Repeat New Password"
          class="form-control" autocomplete="new-password" />
        <span class="icon position-absolute" (click)="togglePasswordType('newPassword')"
          [ngClass]="{ 'icon-show': !isPasswordType('newPassword'), 'icon-hide': isPasswordType('newPassword') }"></span>
        <input-errors [control]="passwordForm.controls.repeatNewPassword" [service]="validationService"></input-errors>
      </div>

      <div class="hr-line-dashed"></div>
      <div class="d-flex justify-content-end mb-25">
        <button type="submit" [disabled]="!passwordForm.valid" class="btn btn-primary px-25">Apply</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #emailModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Change Email</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form (ngSubmit)="onEmailFormSubmit()" [formGroup]="emailForm" class="pos-relative form">
      <div [hidden]="!loading" class="spinner">
        <div class="sk-spinner sk-spinner-pulse medium"></div>
      </div>
      <div class="form-group">
        <label class="form-label required">Enter new email </label>
        <div class="inner-addon right-addon">
          <input [(ngModel)]="emailModel.newEmail" formControlName="newEmail" class="form-control">
        </div>
        <input-errors [control]="emailForm.controls.newEmail" [service]="validationService"></input-errors>
      </div>
      <div class="hr-line-dashed"></div>
      <div class="d-flex justify-content-end mt-15">
        <button id="btn-account-email-apply" type="submit" [disabled]="!emailForm.valid" class="btn btn-primary">Apply</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #devicesModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Connected devices</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body mb-15">
    <app-devices-table></app-devices-table>
  </div>
</ng-template>

<ng-template #companyDetailsModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Confirm Changes</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <p class="text-neutral-n10">
      Updating your company details will require signing a new agreement. Your updated details will only be used for invoicing once that agreement is signed.<br><br>These changes will also apply to all accounts associated with your testing platform.<br><br>

      Are you sure you want to continue?
    </p>
  </div>
  <div class="modal-footer pt-15">
    <div class="d-flex justify-content-end mt-15">
      <button (click)="onConfirmCompanyDetails()" [formGroup]="form" id="btn-company-details-change-confirm" type="button"
        class="btn btn-primary">Confirm</button>
    </div>
  </div>
</ng-template>
